export const SET_DARK_MODE = "SET_DARK_MODE";
export const SET_USER_PROFILE = "SET_USER_PROFILE";
export const SET_IS_USING_MOBILE_APP = "SET_IS_USING_MOBILE_APP";
export const SET_TOKEN = "SET_TOKEN";
export const SET_TOKEN_STATUS = "SET_TOKEN_STATUS";
export const SET_LOGIN_ID = "SET_LOGIN_ID";
export const SET_FRESHCHAT_UNREAD_COUNT = "SET_FRESHCHAT_UNREAD_COUNT";
export const SET_UPI_TRANSACTION_DATA = "SET_UPI_TRANSACTION_DATA";
export const SHOW_REFRESH_PAGE_POPUP = "SHOW_REFRESH_PAGE_POPUP";
export const UPDATE_ORDERS = "UPDATE_ORDERS";
export const FETCH_HISORIC_DATA = "FETCH_HISORIC_DATA";
export const ADD_FAV_PRICE = "ADD_FAV_PRICE";
export const DELETE_FAV_PRICE = "DELETE_FAV_PRICE";
export const SET_MOBILE_TAB = "SET_MOBILE_TAB";
export const SET_SELECTED_COIN = "SET_SELECTED_COIN";
export const SET_REFERRAL = "SET_REFERRAL";
export const SET_COIN_ICONS = "SET_COIN_ICONS";
export const SET_IGNORE_MOBILE_APP = "SET_IGNORE_MOBILE_APP";
export const SET_INNOVATION_DO_NOT_SHOW = "SET_INNOVATION_DO_NOT_SHOW";
export const SET_ACC_POPUP = "SET_ACC_POPUP";
